<template>

  <ui-select
    :name="name"
    :label="label"
    :keys="keys"
    :value="model"
    @input="onInput"
    :options="options"
    :placeholder="placeholder"
    :multiple="true"
    :required="required"
  ></ui-select>

</template>
<script>
import Utils from './../services/Utils'

export default {
  props: {
    value: {
      type: Array,
      default () {
        return []
      }
    },
    options: {
      type: Array,
      default () {
        return []
      }
    },
    name: {
      type: String,
      default: 'unknownName'
    },
    required: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    keys: {
      type: Object,
      default () {
        return Utils.keysForSelect()
      }
    }
  },
  data () {
    return {
      model: this.getBaseModel()
    }
  },
  methods: {
    getBaseModel () {
      return []
    },
    onInput (e) {
      const ids = e.map(el => el[this.keys.value])
      this.selectValue(ids)
    },
    selectValue (ids) {
      const foundObj = this.changeValue(ids)

      if (!foundObj.found) {
        this.clearModel()
      } else {
        this.emitValue(foundObj.value)
      }
    },
    emitValue (value) {
      this.$emit('input', value)
    },
    changeValue (ids) {
      let found = false
      let value = null

      let foundIds = []
      let model = []
      let isIn = false
        // znajdz te id ktore sa w ids
      if (ids) {
        this.options.map((el, i) => {
          isIn = this.isIn(ids, el[this.keys.value])
          if (isIn) {
            model.push(this.options[i])
            foundIds.push(el[this.keys.value])
          }
        })
        if (foundIds.length) {
          found = true
          value = foundIds
          this.model = model
        }
      }

      return {found, value}
    },
    isIn (ids, id) {
      return ids.filter((el, i) => el === id).length > 0
    },
    clearModel () {
      this.model = []
    }
  },
  watch: {
    options: function (n, o) {
      this.selectValue(this.value)
    }
  },
  mounted () {
    this.selectValue(this.value)
  }
}
</script>


// WEBPACK FOOTER //
// ISelectMultiple.vue?7112f23b